import React from 'react';
import { Button as BsButton } from 'react-bootstrap';
import styles from './Button.module.scss';
import { useNavigate } from 'react-router-dom';

type ButtonProps = {
  variant?: string; // Para variações de estilo
  type?: 'button' | 'submit' | 'reset'; // Tipo do botão
  label?: string;
  children?: React.ReactNode; // Para conteúdo interno
  href?: string; // Para navegação
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void; // Alternativamente, função
  className?: string; // Para adicionar classes personalizadas
  isModal?: boolean; // Para ativar modal
  disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  type = 'button',
  label,
  children,
  className = '',
  href,
  onClick,
  isModal = false,
  disabled = false,
}) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    } else if (href && !isModal) {
      navigate(href);
    }
  };

  return (
    <BsButton
      variant={variant}
      type={type}
      className={`${styles['button']} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      {...(isModal && {
        'data-bs-toggle': 'modal',
        'data-bs-target': href,
      })}
    >
      {label}
      {children}
    </BsButton>
  );
};

export default Button;
